<script>
import { router } from '../../router/routes'

export default {
  name: 'CommonMixIn',
  data() {

  },
  methods: {
    getRouterQueryParam(key) {
      const routerQuery = router.app._route.query;
      // eslint-disable-next-line no-prototype-builtins
      if (routerQuery.hasOwnProperty(key)) {
        return routerQuery[key];
      }
    },
    getQueryParams() {
      const urlSearchParams = new URLSearchParams(window.location.search);
      return Object.fromEntries(urlSearchParams.entries());
    },
    urlWithQueryString(url, ...queryArgs) {
      const first = 0;
      queryArgs.forEach((arg, index) => {
        url += (index === first ? '?' : '&');
        url += Object.keys(arg)[first] + '=' + Object.values(arg)[first];
      });
      return url
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
